import {ResolucaoAdicionalIfoodComponent} from './resolucao-adicional-ifood.component';
import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {GridModule} from '@progress/kendo-angular-grid';
import {CanaisVendaFacade} from './canais-venda.facade';
import {TelaCanaisVendaComponent} from './tela-canais-venda/tela-canais-venda.component';
import {MesclagemProdutoCanalVendaComponent} from './mesclagem-produto-canal-venda.component';

@NgModule({
  declarations: [ResolucaoAdicionalIfoodComponent, TelaCanaisVendaComponent, MesclagemProdutoCanalVendaComponent],
  imports: [CommonModule, FormsModule, RouterModule, GridModule],
  providers: [CanaisVendaFacade],
  exports: [TelaCanaisVendaComponent, MesclagemProdutoCanalVendaComponent]
})
export class CanaisVendaModule {}
